export default "__VITE_ASSET__dopJCzF8__"